import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';

const JOIN_COMMUNITY_QUERY = gql`
  mutation joinCommunity {
    joinCommunity
  }
`;

const WITHDRAW_COMMUNITY_QUERY = gql`
  mutation withdrawFromCommunity {
    withdrawFromCommunity
  }
`;

export const joinCommunity = async () => {
  await graphql.mutate({
    mutation: JOIN_COMMUNITY_QUERY,
  });
};

export const withdrawFromCommunity = async () => {
  await graphql.mutate({
    mutation: WITHDRAW_COMMUNITY_QUERY,
  });
};
